<template>
  <v-form v-if="this.user != ''" class="my-0">
    <!-- <div v-if='this.haikuboxesLoaded===false && getDevicesByOwner()'></div> -->
    <v-container fluid>
      <v-card dark class="mx-auto my-2">
        <v-card-title>{{
          t("Haikubox Settings", "Haikubox Settings")
        }}</v-card-title>
        <v-card-subtitle>{{ email }}</v-card-subtitle>

      <v-card color="blue-grey darken-4"
              dark
              class="mx-2 my-8"
              max-width="100%">
        <v-card-title>{{ t('Accessibility')}}</v-card-title>
        <v-switch
            dense
            class="mx-5 mr-5 py-0"
            v-model="hidePics"
            v-tooltip.bottom-start="
              'Hides Images and Graphs for Screen Readers'
            "
            :label="t('hidePics')"
            @change="
              toggleHidePics()
            "
            color="info"
          ></v-switch>
      </v-card>
       
        <v-snackbar v-model="alertSaveSuccess" centered>
          {{ t("Submitted") }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="alertSaveSuccess = false"
            >
              {{ t("Close") }}
            </v-btn>
          </template>
        </v-snackbar>

        <v-snackbar v-model="unclaimUnlockSnackbar" centered timeout="20000">
          {{ t("Unclaim Warning") }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="unclaimUnlockSnackbar = false"
            >
              {{ t("Close") }}
            </v-btn>
          </template>
        </v-snackbar>

        <v-row>
          <v-col
            v-for="(item, index) in devicesByOwner"
            :key="item.componentKey"
            cols="12"
          >
            <v-card
              color="blue-grey darken-4"
              dark
              class="mx-2 my-8"
              max-width="100%"
            >
              <v-card-title
                >Haikubox: {{ item.name }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-subtitle
                >Model: {{ item.model }}
                <v-spacer></v-spacer>
                FCC ID: {{ item.fcc }}
              </v-card-subtitle>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="item.name"
                    placeholder="Enter haikubox name"
                    label="Name"
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-btn
                    color="light-blue darken-1"
                    @click="saveName(item)"
                    dark
                    class="mx-2 my-4"
                    >{{ t("Submit") }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-checkbox
                v-model="item.shareLink"
                class="mx-2"
                :label="t('Share Haikubox')"
                @change="getLink(item)"
              >
              </v-checkbox>
              <v-row v-if="item.linkName != null" no-gutters>
                <v-col cols="9">
                  <v-text-field
                    class="mx-2 my-6"
                    :value="item.linkName"
                    readonly
                    solo
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn @click="copyLink(item.linkName)" class="my-8"
                    >Copy</v-btn
                  >
                  <v-snackbar
                    absolute
                    shaped
                    color="success"
                    v-model="copyLinkSnackbar"
                    :timeout="1000"
                    icon="check_circle"
                  >
                    <v-icon>mdi-check</v-icon>
                    Copied
                  </v-snackbar>
                </v-col>
              </v-row>

              <v-card-title>{{ t("Privacy") }}</v-card-title>
              <v-checkbox
                @change="saveShare(item)"
                v-model="item.hideOnMap"
                class="mx-2"
                :label="t('Make Private')"
                :disabled="!item.subscriptionActive"
              >
              </v-checkbox>
              <v-checkbox
                @change="saveSettings(item)"
                v-if="item.type === 'haikubox'"
                class="mx-2"
                v-model="item.shareBird"
                :label="t('Share Cornell')"
              >
              </v-checkbox>
              <!-- <v-card-text>Firmware Version: {{ item.version }}</v-card-text> -->

              <v-card v-if="item.prepaidType != 'lifetime'">
                <v-card-title>{{ t("Billing") }}</v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <v-card-subtitle v-if="item.stripeCurrentPeriodEndUnix == null">
                  {{ t("Prepaid Period Ends") }}
                  {{ item.prepaidPeriodEndUnix }}</v-card-subtitle
                >
                <v-card-subtitle v-if="item.stripeCurrentPeriodEndUnix != null & item.stripeCurrentPeriodEndUnix==item.prepaidPeriodEndUnix">
                  {{ t("Membership First") }}
                  {{ item.stripeCurrentPeriodEndUnix }}
                </v-card-subtitle>
                <v-card-subtitle v-if="item.stripeCurrentPeriodEndUnix != null & item.autoRenew == true  & item.stripeCurrentPeriodEndUnix!=item.prepaidPeriodEndUnix">
                  {{ t("Membership Renews On") }}
                  {{ item.stripeCurrentPeriodEndUnix }}
                </v-card-subtitle>
                <v-card-subtitle v-if="item.stripeCurrentPeriodEndUnix != null & item.autoRenew == false">
                  {{ t("Membership Ends On") }}
                  {{ item.stripeCurrentPeriodEndUnix }}
                </v-card-subtitle>
                <v-card-subtitle
                  v-if="
                    item.prepaidPeriodEndUnix ===
                    item.stripeCurrentPeriodEndUnix
                  "
                >
                  {{ t("Credit Card") }}
                </v-card-subtitle>
                <v-btn
                  v-if="
                    (item.showPayButton == true) & (item.autoRenew != true)
                  "
                  color="light-green darken-1"
                  @click="getPaymentLink(item.serial)"
                  dark
                  class="mx-2 my-4"
                  >{{ t("Renew Membership") }}
                </v-btn>
                <!-- <v-subtitle
                  v-if="(goNativeActive == true) & (item.showPayButton == true)"
                  >{{ t("Manage Membership") }} https://listen.haikubox.com
                </v-subtitle> -->
                <!-- <v-btn
                  v-if="goNativeActive==true & item.showPayButton==true"
                  color="light-green darken-1"
                  :href="'https://listen.haikubox.com'"
                  target="_blank"
                  dark
                  class="mx-2 my-4"
                  >Manage Membership on Website 
                </v-btn> -->
                <v-btn
                  v-if="(item.autoRenew == true)"
                  color="light-blue darken-1"
                  @click="getPaymentLink(item.serial)"
                  dark
                  class="mx-2 my-4"
                  >{{ t("Manage Subscription") }}
                </v-btn>
                <v-btn
                  v-if="(item.autoRenew == true)"
                  color="darken-1"
                  @click="cancelSubscription(item.serial)"
                  dark
                  class="mx-2 my-4"
                  >{{ t("Cancel Auto-Renew") }}
                </v-btn>
                {{ paymentLinkResponse }}
              </v-card>

              <v-divider></v-divider>
              <v-card>
                <v-card-subtitle>{{ t("Danger Zone") }}</v-card-subtitle>
                <v-btn
                  :disabled="item.unclaimLocked || item.autoRenew"
                  color="blue-grey darken-3"
                  @click="
                    unclaimHaikubox(item.id, item.name, item.serial, index)
                  "
                  class="mx-2 my-4"
                >
                  {{ t("Unclaim Haikubox") }}
                </v-btn>
                <v-btn
                  v-if="item.autoRenew"
                  icon
                  disabled
                  v-tooltip.bottom-start="t('Cancel Auto-Renew to Unclaim')"
                >
                  <v-icon left>mdi-lock</v-icon>
                </v-btn>
                <v-btn
                  v-else-if="item.unclaimLocked === true"
                  icon
                  @click="toggleLock(index)"
                  v-tooltip.bottom-start="t('Unclaim Info')"
                >
                  <v-icon left>mdi-lock</v-icon>
                </v-btn>
                <v-btn
                  v-else-if="item.unclaimLocked === false"
                  icon
                  @click="toggleLock(index)"
                >
                  <v-icon left>mdi-lock-open</v-icon>
                </v-btn>
              </v-card>
            </v-card>
          </v-col>
        </v-row>

        <v-card color="blue-grey darken-4" dark class="mx-2 my-8">
          <v-card-title>{{ t("Weft API Key", "Weft API Key") }}</v-card-title>
          <v-card-subtitle>{{ t("Weft API Key Info", "Use this key to connect Weft desktop app to your account") }}</v-card-subtitle>
          <v-row class="mx-2" v-if="weftApiKey">
            <v-col cols="8">
              <v-text-field
                :value="weftApiKey"
                readonly
                solo
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn @click="copyWeftApiKey()" color="primary" class="mr-4">Copy</v-btn>
              <v-btn @click="regenerateDialog = true" text small>Regenerate</v-btn>
            </v-col>
          </v-row>
          <v-dialog v-model="regenerateDialog" max-width="350">
            <v-card>
              <v-card-title>Regenerate API Key?</v-card-title>
              <v-card-text>This will invalidate your current key. Any apps using it will need to be updated with the new key.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="regenerateDialog = false">Cancel</v-btn>
                <v-btn color="error" text @click="deleteWeftApiKey()">Delete</v-btn>
                <v-btn color="warning" text @click="regenerateWeftApiKey()">Regenerate</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            v-if="!weftApiKey"
            color="light-blue darken-1"
            @click="generateWeftApiKey()"
            dark
            class="mx-4 my-4"
          >{{ t("Generate API Key", "Generate API Key") }}</v-btn>
          <v-snackbar v-model="copyWeftKeySnackbar" :timeout="1000" color="success">
            <v-icon>mdi-check</v-icon>
            Copied
          </v-snackbar>
        </v-card>

        <v-card class="mx-2">
          <v-card-title>{{ t("Delete Account") }}</v-card-title>
          <v-card-subtitle>{{ t("Delete Account Info1") }}</v-card-subtitle>
          <v-dialog v-model="deleteAccountDialog" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-4"
                :disabled="allowDeleteAccount"
                elevation="2"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                >{{ t("Delete Account") }}</v-btn
              >
            </template>
            <v-card>
              <v-card-title class="text-h5">
                {{ t("Delete Account") }}?
              </v-card-title>
              <v-card-subtitle>{{ t("Delete Account Info2") }}</v-card-subtitle>
              <v-card-text>{{ t("Delete Account Warning") }} </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="deleteAccountDialog = false"
                >
                  No
                </v-btn>
                <v-btn color="yellow darken-2" text @click="deleteAccount()">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-card>
    </v-container>
    <v-card>
      <v-btn to="/privacy">{{ t("Privacy", "Privacy") }}</v-btn>
      <v-btn to="/terms">{{ t("Terms", "Terms") }}</v-btn>
    </v-card>
  </v-form>
</template>

<script>
import { API } from "aws-amplify";
import { Auth } from "aws-amplify";
import {
  haikuboxByOwner,
  notifyBirdBySerial,
  oneSignalBySerial,
  getDeviceState,
  stripeUrl,
  getSubscription,
  getUserSettings
} from "../graphql/queries";
import {
  updateDevice,
  createShareMap,
  updateShareMap,
  deleteShareMap,
  deleteDevice,
  deleteNotifyBird,
  deleteOneSignal,
  createUnclaimHaikubox,
  createOrg,
  deleteOrg,
  updateUserSettings,
  createUserSettings
} from "../graphql/mutations";
var moment = require("moment-timezone");
export default {
  name: "Settings",
  props: ["user", "email"],
  created() {
    // get language from local storage or browser
    const haikuboxLanguage = localStorage.getItem("haikuboxLanguage");
    if (haikuboxLanguage != null) {
      this.setLanguage(haikuboxLanguage);
    } else {
      let browserLanguage = navigator.language || navigator.languages[0];
      let browserLang = browserLanguage.split("-")[0];
      // console.log("language", this.browserLang);
      this.setLanguage(browserLang);
    }
  },
  mounted() {
    if (this.user == "") {
      // console.log("no user....wait");
      setTimeout(async () => {
        await this.getDevicesByOwner().then(() => {
          this.getSubscriptionState();
          this.getUserSettings();
        });
        this.getWeftApiKey();
      }, 2000);
    } else {
      this.getDevicesByOwner().then(() => {
        this.getSubscriptionState();
        this.getUserSettings();
      });
      this.getWeftApiKey();
    }

    if (navigator.userAgent.indexOf("gonative") > -1) {
      this.goNativeActive = true;
    }
  },
  data() {
    return {
      devicesByOwner: [],
      claimCode: "",
      alertChangeEmail: false,
      emailChangeStatus: "",
      alertSaveSuccess: false,
      alertClaimSuccess: false,
      alertClaimFail: false,
      unclaimDialog: false,
      unclaimUnlockSnackbar: false,
      deleteAccountDialog: false,
      allowDeleteAccount: false,
      numberOfDevices: null,
      shareMap: true,
      goNativeActive: false,
      haikuboxesLoaded: false,
      copyLinkSnackbar: false,
      paymentLinkResponse: "",
      selectedLanguage: "en",
      currentTranslations: {},
      hidePics: false,
      weftApiKey: null,
      copyWeftKeySnackbar: false,
      regenerateDialog: false
    };
  },
  methods: {
    setLanguage(lang) {
      // console.log(lang);
      if (
        (lang != "da") &
        (lang != "de") &
        (lang != "en") &
        (lang != "es") &
        (lang != "fi") &
        (lang != "fr") &
        (lang != "it") &
        (lang != "nl") &
        (lang != "no") &
        (lang != "pt") &
        (lang != "sv")
      ) {
        lang = "en";
      }
      this.loadTranslations(lang).then((translations) => {
        this.currentTranslations = translations;
      });
      this.selectedLanguage = lang;
    },
    loadTranslations(lang) {
      return fetch(`/I18N/${lang}.json`)
        .then((response) => response.json())
        .then((translations) => {
          return translations;
        });
    },
    t(key, defaultText) {
      return this.currentTranslations[key] || defaultText;
    },
    async getDevicesByOwner() {
      // if(this.user==='') {
      //     this.haikuboxesLoaded = false;
      //     return;
      // }
      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: this.user },
      });
      this.devicesByOwner = devicesByOwner.data.haikuboxByOwner.items;

      for (let i = 0; i < this.devicesByOwner.length; i++) {
        // need to do this for reactivity to work
        this.$set(
          this.devicesByOwner[i],
          "componentKey",
          this.devicesByOwner[i].id
        ); // key so can force DOM update
        this.devicesByOwner[i].unclaimLocked = true;
        if (this.devicesByOwner[i].shareLink == null) {
          this.devicesByOwner[i].shareLink = false;
        }
        if (this.devicesByOwner[i].shareLink == true) {
          this.devicesByOwner[i].linkName =
            "https://birds.haikubox.com/listen/" + this.devicesByOwner[i].id;
        }
        if (this.devicesByOwner[i].serial.length == 21) {
          this.devicesByOwner[i].model = "Haikubox 2";
          this.devicesByOwner[i].fcc = "2AC7Z-ESPS3WROOM1";
        } else {
          this.devicesByOwner[i].model = "Haikubox";
          this.devicesByOwner[i].fcc = "2ABCB-RPICM4";
        }
        if (this.devicesByOwner[i].smsPause == null) {
          this.devicesByOwner[i].smsPause = true;
        }
      }

      this.numberOfDevices = this.devicesByOwner.length;
      this.allowDeleteAccount = this.numberOfDevices > 0;

      // console.log("settings: devices by owner:", this.devicesByOwner);
    },
    async getSubscriptionState() {
      // query subscription state
      for (let i = 0; i < this.devicesByOwner.length; i++) {
        const subState = await API.graphql({
          query: getSubscription,
          variables: { id: this.devicesByOwner[i].serial },
        });
        // console.log(subState);
        this.devicesByOwner[i].prepaidPeriodEndUnix = moment
          .unix(Number(subState.data.getSubscription.prepaidPeriodEndUnix))
          .locale(this.selectedLanguage)
          .format("LL");
        this.devicesByOwner[i].prepaidType =
          subState.data.getSubscription.prepaidType;
        this.devicesByOwner[i].showPayButton = false;
        let currentUnixTime = Math.floor(Date.now() / 1000); // convert ms to s
        this.devicesByOwner[i].subscriptionActive = true;
        if (subState.data.getSubscription.stripeCurrentPeriodEndUnix != null) {
          this.devicesByOwner[i].stripeCurrentPeriodEndUnix = moment
            .unix(
              Number(subState.data.getSubscription.stripeCurrentPeriodEndUnix)
            )
            .locale(this.selectedLanguage)
            .format("LL");

          // check if stripeCurrentPeriodEndUnix is within 1 month of expiring
          let stripeUnix = Number(
            subState.data.getSubscription.stripeCurrentPeriodEndUnix
          );
          if (stripeUnix - currentUnixTime < 0) {
            this.devicesByOwner[i].subscriptionActive = false;
          }
          if (stripeUnix - currentUnixTime < 2630000) {
            this.devicesByOwner[i].showPayButton = true;
          }
        } else {
          // check if prepaidPeriodEnd is expired or within 2 months of expiring
          let prepaidUnix = Number(
            subState.data.getSubscription.prepaidPeriodEndUnix
          );
          // console.log('prepaid, current, diff', prepaidUnix, currentUnixTime, (prepaidUnix - currentUnixTime))
          if (prepaidUnix - currentUnixTime < 5260000) {
            this.devicesByOwner[i].showPayButton = true;
          }
          if (prepaidUnix - currentUnixTime < 0) {
            this.devicesByOwner[i].subscriptionActive = false;
          }
        }
        // subscriptionAutoRenew? (for showing Cancel Auto-renew button)
        this.devicesByOwner[i].autoRenew =
          subState.data.getSubscription.autoRenew;

        // change key to update page
        this.devicesByOwner[i].componentKey =
          this.devicesByOwner[i].componentKey + "1";
      }
    },
    async getUserSettings(){
      const userSettings = await API.graphql({
          query: getUserSettings,
          variables: { id: this.user },
        });
        // no entry yet, update table
        if(userSettings.data.getUserSettings==null){
          this.hidePics = false;
          // console.log(updateItem)
          var createItem = {
            id: this.user,
            owner: this.user,
            hidePics: false,
            createdAt: moment.utc().format(),
            updatedAt: moment.utc().format(),
          }
          await API.graphql({
            query: createUserSettings,
            variables: { input: createItem },
          });
        }
        else{
          this.hidePics = userSettings.data.getUserSettings.hidePics;
        }
    },
    async toggleHidePics(){
      var updateItem = {
            id: this.user,
            owner: this.user,
            hidePics: this.hidePics,
            updatedAt: moment.utc().format(),
          }
      await API.graphql({
        query: updateUserSettings,
        variables: { input: updateItem },
      });
    },
    toggleLock(index) {
      this.devicesByOwner[index].unclaimLocked =
        !this.devicesByOwner[index].unclaimLocked;
      this.devicesByOwner[index].id = this.devicesByOwner[index].id + "_";
      if (this.devicesByOwner[index].unclaimLocked == false)
        this.unclaimUnlockSnackbar = true;
      // console.log(this.devicesByOwner[index]);
    },
    async saveSettings(item) {
      console.log("saveSettings", item);
      var updateItem = JSON.parse(JSON.stringify(item));
      delete updateItem.unclaimLocked;
      delete updateItem.fcc;
      delete updateItem.model;
      delete updateItem.linkName;
      delete updateItem.prepaidPeriodEndUnix;
      delete updateItem.prepaidType;
      delete updateItem.stripeCurrentPeriodEndUnix;
      delete updateItem.autoRenew;
      delete updateItem.componentKey;
      delete updateItem.showPayButton;
      delete updateItem.subscriptionActive;
      delete updateItem.__typename;
      console.log(updateItem)
      updateItem.updatedAt = moment.utc().format();
      await API.graphql({
        query: updateDevice,
        variables: { input: updateItem },
      });
    },
    async saveName(item) {
      this.saveShare(item);  // will also saveSettings
      this.alertSaveSuccess = true;
      if(item.shareLink == true){
        await API.graphql({
          query: deleteOrg,
          variables: { input: { id: item.id } },
        });
        this.getLink(item); // update org table with new name
      }
    },
    async saveShare(item) {
      this.saveSettings(item);
      // create randomized location for sharing
      const shareLat = item.lat + (Math.random() - 0.5) / 50;
      const shareLon = item.lon + (Math.random() - 0.5) / 50;
      const name = item.name;
      //console.log('togglePrivate', shareLat, shareLon);
      let id = item.serial;
      this.shareMap = !item.hideOnMap;
      // console.log('shareMap', this.shareMap, id, shareLat, shareLon, name);
      // say it is online so shows on map and makes people happy
      // if it is disconnected it will update within a day
      let connected = true;
      if (this.shareMap === true) {
        try {
          const mapData = {
            id,
            shareLat,
            shareLon,
            name,
            connected
          };
          await API.graphql({
            query: updateShareMap,
            variables: { input: mapData },
          });
        } catch (err) {
          const mapData = {
            id,
            shareLat,
            shareLon,
            name,
            connected
          };
          await API.graphql({
            query: createShareMap,
            variables: { input: mapData },
          });
        }
      } else {
        // delete existing
        try {
          await API.graphql({
            query: deleteShareMap,
            variables: { input: { id: item.serial } },
          });
        } catch (err) {
          console.log("already deleted");
        }
      }
    },
    async getLink(item) {
      if (item.shareLink == true) {
        item.linkName = "https://birds.haikubox.com/listen/" + item.id;
        // write to org table
        let publicDirectory = false;
        let id = item.id;
        let haikuboxName = item.name;
        let lat = Math.round(item.lat * 100) / 100;
        let lon = Math.round(item.lon * 100) / 100;
        let owner = this.user;

        // console.log(item);
        // get timezone from deviceState
        const deviceState = await API.graphql({
          query: getDeviceState,
          variables: { id: item.serial },
        });
        let tz = deviceState.data.getDeviceState.timezone;

        // create org entry
        const linkData = {
          id,
          haikuboxName,
          lat,
          lon,
          tz,
          publicDirectory,
          owner,
        };
        await API.graphql({
          query: createOrg,
          variables: { input: linkData },
        });
      }
      if (item.shareLink == false) {
        item.linkName = null;
        await API.graphql({
          query: deleteOrg,
          variables: { input: { id: item.id } },
        });
      }
      // update device table
      this.saveSettings(item);
    },
    async copyLink(linkName) {
      this.copyLinkSnackbar = true;
      await navigator.clipboard.writeText(linkName);
    },
    async clearNotifyBird(serial) {
      // delete from notifyBird table
      // get id's for serial in notifyBird table
      // console.log("clearNotifyBird: ", serial)
      var nextToken = null;
      var notifyList = [];
      do {
        var notifyObjects = await API.graphql({
          query: notifyBirdBySerial,
          variables: { serial: serial },
        });
        var allNotifications = notifyObjects.data.notifyBirdBySerial.items;
        // console.log(allNotifications)
        nextToken = notifyObjects.data.notifyBirdBySerial.nextToken;
        for (let i = 0; i < allNotifications.length; i++) {
          notifyList.push(allNotifications[i].id);
        }
      } while (nextToken != null);

      for (let i = 0; i < notifyList.length; i++) {
        await API.graphql({
          query: deleteNotifyBird,
          variables: { input: { id: notifyList[i] } },
        });
      }
    },
    async clearOneSignal(serial) {
      // delete from oneSignal table
      // get id's for serial in oneSignal table
      // console.log("clearOneSignal: ", serial)
      var nextToken = null;
      var oneSignalList = [];
      do {
        var oneSignalObjects = await API.graphql({
          query: oneSignalBySerial,
          variables: { serial: serial },
        });
        var allPlayers = oneSignalObjects.data.oneSignalBySerial.items;
        nextToken = oneSignalObjects.data.oneSignalBySerial.nextToken;
        for (let i = 0; i < allPlayers.length; i++) {
          oneSignalList.push(allPlayers[i].id);
        }
      } while (nextToken != null);

      for (let i = 0; i < oneSignalList.length; i++) {
        await API.graphql({
          query: deleteOneSignal,
          variables: { input: { id: oneSignalList[i] } },
        });
      }
    },
    async unclaimHaikubox(id, name, serial, index) {
      id = id.replaceAll("_", "");
      this.unclaimDialog = false;

      // delete from Device Table
      await API.graphql({
        query: deleteDevice,
        variables: { input: { id: id } },
      });
      this.devicesByOwner.splice(index, 1);
      this.numberOfDevices = this.numberOfDevices--;
      this.allowDeleteAccount = this.numberOfDevices > 0;

      this.clearNotifyBird(serial);
      this.clearOneSignal(serial);

      // log unclaim in table
      const unclaimData = {
        owner: this.user,
        serial: serial,
        email: this.email,
      };

      await API.graphql({
        query: createUnclaimHaikubox,
        variables: { input: unclaimData },
      });

      // delete from shareMap table (if present)
      try {
        await API.graphql({
          query: deleteShareMap,
          variables: { input: { id: serial } },
        });
      } catch (err) {
        console.log("Not present");
      }

      // console.log("index", index);
      // console.log("removed from list", this.devicesByOwner);
    },
    async deleteAccount() {
      // console.log('delete account');
      this.deleteAccountDialog = false;

      try {
        const userToDelete = await Auth.currentAuthenticatedUser();
        // console.log("userToDelete", userToDelete);
        userToDelete.deleteUser();
        setTimeout(this.refreshPage, 5000);
      } catch (error) {
        console.log("Error deleting user", error);
      }
    },
    async refreshPage() {
      await Auth.signOut();
      this.$router.push({ path: "/" });
      location.reload();
    },
    async getPaymentLink(serial) {
      // console.log('getPaymentLink', serial);
      try {
        const stripeReturn = await API.graphql({
          query: stripeUrl,
          variables: {
            serial: serial,
            owner: this.user,
            email: this.email,
            autoRenew: true,
          },
        });
        const item = JSON.parse(stripeReturn.data.stripeUrl);
        console.log(item);
        // if get 303 with url, redirect
        // anything else show Error message
        if (item.statusCode == 303) {
          this.paymentLinkResponse = "";
          window.location = item.url;
        } else {
          this.paymentLinkResponse = item.msg;
        }
      } catch (err) {
        console.log("Not present");
      }
    },
    async cancelSubscription(serial) {
      console.log("cancelSubscription", serial);
      try {
        const stripeReturn = await API.graphql({
          query: stripeUrl,
          variables: {
            serial: serial,
            owner: this.user,
            email: this.email,
            autoRenew: false,
          },
        });
        const item = JSON.parse(stripeReturn.data.stripeUrl);
        console.log(item);
        this.paymentLinkResponse = item.msg;
      } catch (err) {
        console.log("Query failed");
      }
    },
    async getWeftApiKey() {
      const getOfflineApiQuery = `
        query GetOfflineApi($id: ID!) {
          getOfflineApi(id: $id) {
            id
            owner
            okey
          }
        }
      `;
      try {
        const result = await API.graphql({
          query: getOfflineApiQuery,
          variables: { id: this.user },
        });
        console.log("getWeftApiKey result:", result);
        if (result.data.getOfflineApi && result.data.getOfflineApi.okey) {
          this.weftApiKey = result.data.getOfflineApi.okey;
        }
      } catch (err) {
        console.log("No Weft API key found", err);
      }
    },
    async generateWeftApiKey() {
      const uuid = "weft_" + crypto.randomUUID();
      const createOfflineApiMutation = `
        mutation CreateOfflineApi($input: CreateOfflineApiInput!) {
          createOfflineApi(input: $input) {
            id
            owner
            okey
          }
        }
      `;
      const updateOfflineApiMutation = `
        mutation UpdateOfflineApi($input: UpdateOfflineApiInput!) {
          updateOfflineApi(input: $input) {
            id
            owner
            okey
          }
        }
      `;
      const input = {
        id: this.user,
        owner: this.user,
        okey: uuid,
      };
      try {
        // Try to create first
        await API.graphql({
          query: createOfflineApiMutation,
          variables: { input },
        });
        this.weftApiKey = uuid;
      } catch (err) {
        // If already exists, update instead
        try {
          await API.graphql({
            query: updateOfflineApiMutation,
            variables: { input },
          });
          this.weftApiKey = uuid;
        } catch (updateErr) {
          console.log("Failed to generate API key", updateErr);
        }
      }
    },
    async copyWeftApiKey() {
      this.copyWeftKeySnackbar = true;
      await navigator.clipboard.writeText(this.weftApiKey);
    },
    async regenerateWeftApiKey() {
      this.regenerateDialog = false;
      const uuid = "weft_" + crypto.randomUUID();
      const updateOfflineApiMutation = `
        mutation UpdateOfflineApi($input: UpdateOfflineApiInput!) {
          updateOfflineApi(input: $input) {
            id
            owner
            okey
          }
        }
      `;
      const input = {
        id: this.user,
        okey: uuid,
      };
      try {
        await API.graphql({
          query: updateOfflineApiMutation,
          variables: { input },
        });
        this.weftApiKey = uuid;
      } catch (err) {
        console.log("Failed to regenerate API key", err);
      }
    },
    async deleteWeftApiKey() {
      this.regenerateDialog = false;
      const deleteOfflineApiMutation = `
        mutation DeleteOfflineApi($input: DeleteOfflineApiInput!) {
          deleteOfflineApi(input: $input) {
            id
          }
        }
      `;
      const input = {
        id: this.user,
      };
      try {
        await API.graphql({
          query: deleteOfflineApiMutation,
          variables: { input },
        });
        this.weftApiKey = null;
      } catch (err) {
        console.log("Failed to delete API key", err);
      }
    },
  },
};
</script>
